import { render, staticRenderFns } from "./IconSvgLogout.vue?vue&type=template&id=4fa3b423&scoped=true&"
import script from "./IconSvgLogout.vue?vue&type=script&lang=js&"
export * from "./IconSvgLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa3b423",
  null
  
)

export default component.exports